module.exports = __webpack_public_path__ + "img/gear-solid.e75d7cc9.svg";